import Box from '@passkeys/ui/box';

import Collectible from '@/ui/components/collectible';
import type { Nft } from '@/ui/types';
import { getChainFromNft } from '@/ui/utils/nfts';

type CollectibleItemProps = {
  data: Nft;
  onClick: () => void;
};

function CollectibleItem({ data, onClick }: CollectibleItemProps) {
  const chain = getChainFromNft(data);

  return (
    <button
      className="transition-opacity hover:opacity-50"
      type="button"
      data-testid="collectible-item-button"
      onClick={onClick}
    >
      <Box className="overflow-hidden p-2 pb-4" size="medium">
        <Collectible
          image={data.image}
          name={data.name}
          collectionName={data.collectionName}
          chain={chain}
          size="small"
        />
      </Box>
    </button>
  );
}

export default CollectibleItem;
